import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideLucideIcons, LucideBell, LucideBuilding2, LucideCalendarDays, LucideCircleDot, LucideFileText, LucideFolderKanban, LucideGlasses, LucideLayoutDashboard, LucideListTodo, LucideLogOut, LucideMenu, LucidePackage, LucideSearch, LucideShield, LucideTruck, LucideUsers } from '@lucide/angular';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';

import { apiFeedbackInterceptor } from './core/api-feedback.interceptor';
import { authInterceptor } from './core/auth.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, apiFeedbackInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      },
      ripple: true
    }),
    provideLucideIcons(
      LucideBell,
      LucideBuilding2,
      LucideCalendarDays,
      LucideCircleDot,
      LucideFileText,
      LucideFolderKanban,
      LucideGlasses,
      LucideLayoutDashboard,
      LucideListTodo,
      LucideLogOut,
      LucideMenu,
      LucidePackage,
      LucideSearch,
      LucideShield,
      LucideTruck,
      LucideUsers
    )
  ]
};
